import config from "../../config/config";
import axios from "axios";
import { getToken } from "../../common";

export const buyerDeleteAPI = async (buyerId) => {
  return await axios({
    method: "delete",
    url: `${config.api.base_url}dashboard/buyers/${buyerId}`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default buyerDeleteAPI;
